import { LoginRequest, LoginResponse } from '@/types/apis/auth'

import axios from './axios'

const API_ENDPOINT = '/auth'

export const loginApi = (request: LoginRequest): Promise<LoginResponse> => {
  return axios.post(`${API_ENDPOINT}/login`, request)
}
